import React from "react";
import { SpinnerWrapper } from "./CommonStyles";
import Colors from "../../themes/Colors";

const Spinner = ({ size = 40, colorBorder, colorBorderTop }) => {
  return (
    <SpinnerWrapper
      size={size}
      colorBorder={colorBorder || Colors.white}
      colorBorderTop={colorBorderTop || Colors.primaryHumano}
    />
  );
};

export default Spinner;